var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingCardDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#080A09"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4688 14.7656C12.4688 15.0245 12.2589 15.2344 12 15.2344H9.23438C8.97548 15.2344 8.76562 15.0245 8.76562 14.7656C8.76562 14.5067 8.97548 14.2969 9.23438 14.2969H12C12.2589 14.2969 12.4688 14.5067 12.4688 14.7656ZM18 8.81602V14.3047C18 15.0244 17.7197 15.701 17.2108 16.2099L16.2099 17.2108C15.701 17.7197 15.0244 18 14.3047 18H8.81602C7.25951 18 6 16.7404 6 15.184V8.81602C6 7.25951 7.25965 6 8.81602 6H15.184C16.7405 6 18 7.25965 18 8.81602ZM16.9996 14.7734H15.7109C15.194 14.7734 14.7734 15.194 14.7734 15.7109V16.9996C15.0632 16.9199 15.3287 16.7662 15.547 16.5479L16.5479 15.547C16.7662 15.3287 16.9199 15.0632 16.9996 14.7734ZM17.0625 8.81602C17.0625 7.77771 16.2222 6.9375 15.184 6.9375H8.81602C7.77771 6.9375 6.9375 7.77776 6.9375 8.81602V15.184C6.9375 16.2223 7.77776 17.0625 8.81602 17.0625H13.8359V15.7109C13.8359 14.6771 14.6771 13.8359 15.7109 13.8359H17.0625V8.81602ZM14.7656 11.5312H9.23438C8.97548 11.5312 8.76562 11.7411 8.76562 12C8.76562 12.2589 8.97548 12.4688 9.23438 12.4688H14.7656C15.0245 12.4688 15.2344 12.2589 15.2344 12C15.2344 11.7411 15.0245 11.5312 14.7656 11.5312ZM14.7656 8.76562H9.23438C8.97548 8.76562 8.76562 8.97548 8.76562 9.23438C8.76562 9.49327 8.97548 9.70312 9.23438 9.70312H14.7656C15.0245 9.70312 15.2344 9.49327 15.2344 9.23438C15.2344 8.97548 15.0245 8.76562 14.7656 8.76562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingCardDocumentIcon);
export default __webpack_public_path__ + "static/media/booking-card-document-icon.5b14b4491067f4ff76746f5d38039590.svg";
export { ForwardRef as ReactComponent };